<template>
  <div>
    <!--课程统计-->
    <div class="row">
      <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width: 360px;">
                 <div class="v-list-item v-list-item--three-line theme--light" @click="majorList()">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            专业总数
                         </div>
                         <div class="v-list-item__subtitle" style="color: rgb(52, 52, 52); font-size: 24px; font-weight: bold;">
                            {{majorTotalCount}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new">
                            <!--响应式图片-->
                              <img src="@/assets/major.png" class="img-xys" >
                          </div>
                   </div>
                 </div>
             </div>
      </div>
       <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width: 360px;">
                 <div class="v-list-item v-list-item--three-line theme--light"  @click="courseList()">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            课程总数
                         </div>
                         <div class="v-list-item__subtitle" style="color: #FF9F7F; font-size: 24px; font-weight: bold;">
                            {{courseTotalCount}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new1">
                             <!--响应式图片-->
                              <img src="@/assets/course.png" class="img-xys">
                          </div>
                   </div>
                 </div>
             </div>
      </div>
       <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width: 360px;" >
                 <div class="v-list-item v-list-item--three-line theme--light" @click="lessonList()">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            章节总数
                         </div>
                         <div class="v-list-item__subtitle" style="color:#FFD700; font-size: 24px; font-weight: bold;">
                            {{lessionTotalCount}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new2">
                             <!--响应式图片-->
                              <img src="@/assets/lesson.png" class="img-xys"  >
                          </div>
                   </div>
                 </div>
             </div>
      </div>

      <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width:360px;">
                 <div class="v-list-item v-list-item--three-line theme--light" @click="classList()">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            班级总数
                         </div>
                         <div class="v-list-item__subtitle" style="color:#C0FF3E; font-size: 24px; font-weight: bold;">
                            {{classTotalCount}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new3">
                             <!--响应式图片-->
                              <img src="@/assets/class.png" class="img-xys" >
                          </div>
                   </div>
                 </div>
             </div>
      </div>

      <div class="col-sm-2">
             <div class="v-card" style="max-height: 100px; max-width: 360px;" @click="displayStudentList()">
                 <div class="v-list-item v-list-item--three-line theme--light">
                   <div class="v-list-item__content">
                         <div class="v-list-item__title" style="color: rgb(148, 148, 148);">
                            学员总数
                         </div>
                         <div class="v-list-item__subtitle" style="color:#E066FF; font-size: 24px; font-weight: bold;">
                            {{studentTotalCount}}
                         </div>
                   </div>
                   <div class="v-avatar v-list-item__avatar" style="height: 40px; min-width: 40px; width: 40px;">
                          <div class="tip_new4">
                             <!--响应式图片-->
                              <img src="@/assets/student.png" class="img-xys" >
                          </div>
                   </div>
                 </div>
             </div>
      </div>
    </div>
    <!--签到统计-->
    <div class="box1">
         <div class="sign_item_param">
              <div class="sign_title">
                <span>
                  签到统计
                </span>
              </div>
              <hr>
              <div class="sign_search_param">
                <div class="sign_label_1">
                     <div class="sign_label">
                        最近{{signDays}}日
                     </div>
                </div>
                <div class="sign_date">
                     <BInputDateRange
                      v-model="createTime"
                      from-text=""
                      to-text="至"
                      @startDateChange="startDateChange"
                      @endDateChange="endDateChange"
                    />
                </div>
              </div>
         </div>
         <div class="sign_item" id="sign_div">
             <!--签到柱状图-->
         </div>
    </div>
    <!--今日top10课程-->
    <div class="box1_top_course">
         <div class="top_course_item_param">
              <div class="top_course_title">
                <span class="top_course_span">
                  今日课程学习热度TOP10
                </span>
              </div>
              <hr>
         </div>
         <div class="top_course_item" id="top_course_div">
             <!--今日top10课程柱状图-->
         </div>
    </div>
  </div>
</template>
<script>
import * as echarts from 'echarts';
import Vue from "vue";
import {
  homeStatisticsSearch,
  trainSignStatisticsData,
  topCourseDataSearch,
} from "@/api/dashboard";
import BInputDateRange from "../../components2/BInputDateRange";
export default {
  name: "CourseManagement",
  components: {
    BInputDateRange,
  },
  data: () => ({
    totalPages: 0,
    page: 1,
    limit: 10,
    totalCount: 0,
    createTime: {
      from: "",
      to: "",
    },
    searchParam: {
      appType: "",
      version: "",
      updateFlg: "",
      enableFlg: "",
    },
    appTypeList: [],
    signXDataList: [],
    signYDataList: [],
    signMaxCount: 0,
    appVersionList:[],
    totalCounts: "",
    deleteId: "",
    data: {},
    majorTotalCount: 0,//专业总数量
    courseTotalCount: 0,//课程总数量
    lessionTotalCount: 0,//课时总数量
    classTotalCount: 0,//班级总数量
    studentTotalCount: 0,//学员总数量
    signDays:7,
    fillTime:7,
    top10CourseXDataList: [],
    top10CourseYDataList: [],
    top10CourseMaxCount: 0,
    navi: [{ name: "dashboard" }],
  }),
  beforeMount() {
    this.$store.commit('SET_NAVI_DATA', this.navi);
  },
  // 页面载入之前
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      //vm.getDate();
      vm.searchData();
      //vm.searchSignData();
    });
  },
  created() {
    this.getDate();
    this.searchSignData();
    this.searchTop10CourseData();
  },
  mounted() {
     //this.draw_top_course()
  },
  methods: {
    getDate(){
      var myDate = new Date();
      var time= myDate.getTime();
      this.createTime.to = this.dateToStr(myDate)
      //获取 6天的 毫秒数
      var sevenTime = 6*24*60*60*1000;
      //当前时间 毫秒数- 6天的毫秒数= 7天之间那天的毫秒数
      var times = time - sevenTime;
      //将毫秒数转日期
      var startDate=new Date(times);
      this.createTime.from = this.dateToStr(startDate)
    },
    dateToStr(date){
      var year = date.getFullYear(); 
      var month =(date.getMonth() + 1).toString(); 
      var day = (date.getDate()).toString();  
      if (month.length == 1) { 
          month = "0" + month; 
      } 
      if (day.length == 1) { 
          day = "0" + day; 
      }
      var dateTime = year + "-" + month + "-" + day;
      return dateTime; 
    },
     // 保存check
    signSearchCheck() {
        // 课程时间
        if (
            this.createTime.from === "" ||
            this.createTime.from === undefined ||
            this.createTime.from === null
        ) {
            Vue.prototype.$valertbar.show("请选择签到开始日期");
            return false;
        }
      
        if (
            this.createTime.to === "" ||
            this.createTime.to === undefined ||
            this.createTime.to === null
        ) {
            Vue.prototype.$valertbar.show("请选择签到结束日期");
            return false;
        }
        if (
            new Date(this.createTime.from).getTime() >
            new Date(this.createTime.to).getTime()
        ) {
            Vue.prototype.$valertbar.show("结束日期要大于或等于开始日期");
            return false;
        }

        var days = this.getNumberOfDays(this.createTime.from,this.createTime.to);

        this.signDays = days + 1
        if(this.signDays > 31){
            Vue.prototype.$valertbar.show("最大仅支持31天内的签到查询");
            return false;
        }
        return true;
    },
    // 查询统计数据
    async searchData() {
      const data = await homeStatisticsSearch();
      //专业总数量
      this.majorTotalCount = data.data.majorTotalCount
      //课程总数量
      this.courseTotalCount = data.data.courseTotalCount
      //课时总数量
      this.lessionTotalCount = data.data.lessionTotalCount
      //班级总数量
      this.classTotalCount = data.data.classTotalCount
      //学员总数量
      this.studentTotalCount = data.data.studentTotalCount 
    },
    // 查询签到数据
    async searchSignData() {
      var param = {
        startDate: this.createTime.from,
        endDate: this.createTime.to,
      };
      const data = await trainSignStatisticsData(param);
      this.signMaxCount = data.data.maxSignCount;
      this.signXDataList = data.data.xsignData,
      this.signYDataList = data.data.ysignData;
      this.drawLine_sign()
    },
    // 查询签到数据
    async searchTop10CourseData() {
      const data = await topCourseDataSearch();
      this.top10CourseMaxCount = data.data.topCourseMaxCount;
      this.top10CourseXDataList = data.data.xtopCourseData,
      this.top10CourseYDataList = data.data.ytopCourseData;
      this.draw_top_course()
    },
    // 小于350
    drawLine_sign(){
      // var that = this;
      var chartDom = document.getElementById('sign_div');
      var myChart = echarts.init(chartDom);
      window.onresize = function () {
        myChart.resize()
      }
      myChart.setOption({}, true)
      var option;
      option = {
        grid:{
                x:40,
                y:45,
                x2:5,
                y2:20,
                borderWidth:1
        },
        tooltip: {
              trigger: 'axis',
              axisPointer: {
                  type: 'cross'
              }
        },
        xAxis: {
            type: 'category',
            data: this.signXDataList
            //data: ['周一','周二','周三','周四','周五','周六','周日']
        },
        yAxis: {
            type: 'value',
            name: '次数',
        },
        series: [{
            //data: [120, 232, 101, 134, 190, 30, 320],
            data: this.signYDataList,
            type: 'line',
            color: '#AAFFEE',
            itemStyle: {  
                normal: { //颜色渐变函数 前四个参数分别表示四个位置依次为左、下、右、上
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1,[{
                            offset: 0, color: '#bfeaf1' // 0% 处的颜色
                        }, {
                            offset: 0.3, color: '#bfeaf1' // 100% 处的颜色
                        }, {
                            offset: 1, color: '#fff' // 100% 处的颜色
                        }]
                    ), //背景渐变色    
                    lineStyle: {        // 系列级个性化折线样式  
                        width: 3,  
                        type: 'solid',  
                        color: "#97d9e5" //折线的颜色
                    }  
                },  
            },//线条样式
            symbolSize:5, //折线点的大小
            label: {
                normal: {
                    show: true,
                    position: 'top'
                }
            },
            areaStyle: {normal: {}},
        }]
      };
      // if (that.signMaxCount <= 70) {
      //   option.yAxis.interval = 10;
      //   option.yAxis.max = 70;
      //   option.yAxis.min = 0;
      // } else if (that.signMaxCount > 70 &&
      //   that.signMaxCount <=350) {
      //   option.yAxis.interval = 50;
      //   option.yAxis.max = 350;
      //   option.yAxis.min = 0;
      // } else if (
      //   that.signMaxCount > 350 &&
      //   that.signMaxCount <= 700
      // ) {
      //   option.yAxis.interval = 100;
      //   option.yAxis.max = 700;
      //   option.yAxis.min = 0;
      // } else {
      //   option.yAxis.interval = 150;
      //   option.yAxis.max = 1050;
      //   option.yAxis.min = 0;
      // }
      option && myChart.setOption(option);
    },
    draw_top_course(){
      // var that = this;
      var chartDom = document.getElementById('top_course_div');
      var myChart = echarts.init(chartDom);
      window.onresize = function () {
        myChart.resize()
      }
      myChart.setOption({}, true)
      var option;
      option = {
        grid:{
                x:40,
                y:45,
                x2:5,
                y2:20,
                borderWidth:1
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        xAxis: {
            type: 'category',
            //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            data: this.top10CourseXDataList,
        },
        yAxis: {
            type: 'value',
            name: '次数',
        },
        series: [{
            itemStyle: {
              normal: {
                  barBorderRadius: 7,
                   color: new echarts.graphic.LinearGradient(
                    0, 0, 0, 1,
                    [
                        {offset: 0, color: '#86d0e9'},
                        {offset: 0.5, color: '#969ae1'},
                        {offset: 1, color: '#969ae1'}
                    ]
                )
              }
            },
            //data: [120, 200, 150, 80, 70, 110, 130],
            data: this.top10CourseYDataList,
            type: 'bar',
            color: '#03BB7A',
            barWidth: 20//设置柱子宽度，单位为px
        }]
      };
      // if (that.top10CourseMaxCount <= 70) {
      //   option.yAxis.interval = 10;
      //   option.yAxis.max = 70;
      //   option.yAxis.min = 0;
      // } else if (that.top10CourseMaxCount > 70 &&
      //   that.top10CourseMaxCount <=350) {
      //   option.yAxis.interval = 50;
      //   option.yAxis.max = 350;
      //   option.yAxis.min = 0;
      // } else if (
      //   that.top10CourseMaxCount > 350 &&
      //   that.top10CourseMaxCount <= 700
      // ) {
      //   option.yAxis.interval = 100;
      //   option.yAxis.max = 700;
      //   option.yAxis.min = 0;
      // } else {
      //   option.yAxis.interval = 150;
      //   option.yAxis.max = 1050;
      //   option.yAxis.min = 0;
      // }
      option && myChart.setOption(option);
    },
    startDateChange(value) {
      this.createTime.from = value;
      var days = this.getNumberOfDays(this.createTime.from,this.createTime.to);
      this.signDays = days + 1
      if(this.signSearchCheck() === true){
        this.searchSignData()
      }
    },
    endDateChange(value) {
      this.createTime.to = value;
      var days = this.getNumberOfDays(this.createTime.from,this.createTime.to);
      this.signDays = days + 1
      if(this.signSearchCheck() === true){
        this.searchSignData()
      }
    },
    getNumberOfDays(date1,date2){//获得天数
      //date1：开始日期，date2结束日期
      var a1 = Date.parse(new Date(date1));
      var a2 = Date.parse(new Date(date2));
      var day = parseInt((a2-a1)/ (1000 * 60 * 60 * 24));//核心：时间戳相减，然后除以天数
      return day
    },
    // 课程清单
    courseList() {
       this.$router.push({
          name: "display-course-list",
          params:{removeFlg:'1'},
      });
    },
    // 章节清单
    lessonList() {
      this.$router.push({
          name: "display-lesson-list",
          params:{removeFlg:'1'},
        });
    },
    // 班级清单
    classList() {
      this.$router.push({
          name: "display-class-list",
        });
    },
    // 学员清单
    displayStudentList() {
      this.$router.push({
          name: "display_student_list",
      });
    },
    // 章节清单
    majorList() {
      this.$router.push({
          name: "display-major-list",
        });
    },
  },
  destroyed() {

  },
};
</script>

<style scoped>
.v-list-item__avatar {
    -ms-flex-item-align: start;
    align-self: flex-start;
    margin-top: 16px;
    margin-bottom: 16px;
}
.v-avatar {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    border-radius: 50%;
    display: -webkit-inline-box;
    display: -ms-inline-flexbox;
    display: inline-flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
    line-height: normal;
    position: relative;
    text-align: center;
    vertical-align: middle;
    overflow: hidden;
}
.v-list-item__subtitle {
    margin-left: 20px;
    white-space: normal;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -webkit-box;
}
.v-list-item__title {
    -ms-flex-item-align: center;
    align-self: center;
    /* font-size: .929rem; */
}
.v-list-item__subtitle, .v-list-item__title {
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.v-list-item__content {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -ms-flex-item-align: center;
    align-self: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    -webkit-box-flex: 1;
    -ms-flex: 1 1;
    flex: 1 1;
    overflow: hidden;
    padding: 12px 0;
}
.v-list-item {
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-flex: 1;
    -ms-flex: 1 1 100%;
    flex: 1 1 100%;
    letter-spacing: normal;
    min-height: 48px;
    outline: none;
    padding: 0 16px;
    position: relative;
    text-decoration: none;
}

.v-list-item--three-line {
    min-height: 88px;
}
.v-card {
    border: 1px solid #D0D0D0;
    border-width: thin;
    display: block;
    max-width: 100%;
    outline: none;
    text-decoration: none;
    -webkit-transition-property: opacity,-webkit-box-shadow;
    transition-property: opacity,-webkit-box-shadow;
    transition-property: box-shadow,opacity;
    transition-property: box-shadow,opacity,-webkit-box-shadow;
    overflow-wrap: break-word;
    position: relative;
    white-space: normal;
}

.v-card--link {
    cursor: pointer;
}

.col-sm-2 {
    display: block;
    float: left;
    width: 15%;
    height: 90px;
    margin-left:28px;
    margin-right: 40px;
}

.col-12 {
    -webkit-box-flex: 0;
    -ms-flex: 0 0 100%;
    flex: 0 0 100%;
    max-width: 100%;
}

.row{
     display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    height: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
}

.img-xys{
  display: inline-block;
  height: auto;
  max-width: 100%;
}
hr{
   border: 1px solid #EEE;
   float: left; 
   width: 99%;
}

.box_new {
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    justify-content: space-around;
    height: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
}

.item_new {
    border: 1px solid #D0D0D0;
    width: 15%;
    height: 90px;
    margin-left:28px;
    margin-right: 40px;
}

.tip_new{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}
.tip_new1{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}
.tip_new2{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}

.tip_new3{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}

.tip_new4{
  display: block;
  float: left;
  width: 30px;
  height: 30px;
  -webkit-border-radius:50px;
  -moz-border-radius:50px;
  -o-border-radius:50px;
  border-radius:50px;
}


.course_item_new{
    width: 95%;
    height: 320px;
    margin-left: 10px;
    margin-bottom: 0px;
    padding: 0px;
}

.course_title_new{
  display: inline;
  height: 80px;
}

.course_title_span_new{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.major_count{
  font-size: 30px;
  color: #7EC0EE;
}

.course_count{
  font-size: 30px;
  color: #FF9F7F;
}

.lesson_count{
  font-size: 30px;
  color: #FFD700;
}

.class_count{
  font-size: 30px;
  color: #C0FF3E;
}

.student_count{
  font-size: 30px;
  color: #E066FF;
}

.course_img_new{
  width: 100%;
  height: 200px;
  padding: 0px;
  margin-bottom: 0px;
}

.box1 {
    display: flex;
    flex-wrap: wrap;
    height: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
}

.box1_top_course {
    display: flex;
    flex-wrap: wrap;
    height: 90%;
    margin-top: 10px;
    margin-bottom: 10px;
}
.top_course_item_param {
    display: inline;
    width: 95%;
    height: 50px;
    margin-left:40px;
}

.sign_item_param {
    display: inline;
    width: 95%;
    height: 140px;
    margin-left:40px;
}

.sign_date{
  width: 460px;
  height: 60px;
  float: right;
  margin-right:20px;
  padding-left: 0px;
}

.sign_item {
    border: 1px solid #F0F0F0;
    display: inline;
    width: 95%;
    height: 500px;
    margin-left: 40px;
}

.sign_title{
  display: inline;
  height: 80px;
}

.top_course_title{
  display: inline;
  height: 80px;
}

.sign_search_param{
  display: flex;
  align-items: right;
  height: 100px;
  width: 600px;
  padding-top: 10px;
  float: right;
}

.sign_label_1{
  display: block;
  height: 40px;
  width: 200px;
  float: right;
  margin-top: 15px;
}

.sign_label{
  display: flex;
  /*width: 110px;*/
  height: 38px;
  background:#0169a6;
  color: #FEFEFE;
  justify-content: center;
  align-items: center;
  margin: 0 0.5em 0 0;
  cursor: pointer;
  font-size: 14px;
  padding: 10 1em;
}

.sign_title span{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.teacher_title{
  display: inline;
  height: 80px;
}

.teacher_title_span{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.teacher_img{
  width: 100%;
  height: 270px;
  padding: 0px;
  margin-bottom: 0px;
}

.course_title{
  display: inline;
  height: 80px;
}

.course_title_span{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.course_img{
  width: 100%;
  height: 270px;
  padding: 0px;
  margin-bottom: 0px;
}

.box2 {
    background-color: #F0F0F0;
    display: flex;
    flex-wrap: wrap;
    height: 100%;
    margin-top: 10px;
    margin-bottom: 10px;
}

.top_course_item {
    border: 1px solid #F0F0F0;
    display: inline;
    width: 95%;
    height: 500px;
    margin-left: 40px;
    padding: 0px;
}


.top_course_span{
  display: block;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}
</style>
